import React from 'react';

import { BookSortingEnum } from '~/api/book/bookApiTypes';
import { AuthorLink, CycleLink } from '~/atomic/atom/links/dynamicLinks';
import { getBooks } from '~/atomic/page/catalog/tagPage/tagPage.data';
import { tagFiltersSelector } from '~/atomic/page/catalog/tagPage/tagPage.selector';
import { Contest } from '~/atomic/page/contest/Contest';
import { catalogFilterActions } from '~/feature/catalog/filter/catalogFilter.slice';
import { paginationActions } from '~/feature/pagination/pagination.slice';
import { useAppDispatch, useAppSelector } from '~/store';

export const CONTEST_STORY_SAPPHIRE_TAG_SLUG = 'konkurs-rasskazov-sapfir';

export const ContestStorySapphire = () => {
  const dispatch = useAppDispatch();
  const { books, isLoadBooks } = useAppSelector(tagFiltersSelector);

  const onLoadBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 100 }));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_STORY_SAPPHIRE_TAG_SLUG));
    dispatch(getBooks());
  };

  const onLoadSidebarBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 6 }));
    dispatch(catalogFilterActions.setBookSorting(BookSortingEnum.Rand));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_STORY_SAPPHIRE_TAG_SLUG));
    dispatch(getBooks());
  };

  return (
    <Contest
      bannerProps={{ bannerSrc: '/image/contest/story-sapphire/banner.jpg' }}
      commentProps={{
        targetId: 665,
        targetAuthorId: String(1),
      }}
      contestBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks,
        description: 'Лонг-лист «Конкурс рассказов Сапфир».',
      }}
      contestSidebarBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks: onLoadSidebarBooks,
      }}
      descriptionProps={{
        content: (
          <>
            <p>
              {' '}
              <AuthorLink
                username="yasmina-sapfir"
              >
                <a>Ясмина Сапфир</a>
              </AuthorLink>
              , портал «Букривер» и издательство «Т8» объявляют конкурс рассказов!
            </p>
            <p>
              Это не просто конкурс рассказов,
              вы можете написать кроссовер по миру «Перекрестья»!
              А точнее, по циклу книг
              {' '}
              <CycleLink
                authorUsername="yasmina-sapfir"
                slug="ubitnelzyanauchit"
              >
                <a>«Убить нельзя научить»</a>
              </CycleLink>
              {' '}
              (первые книги цикла бесплатны на Bookriver).
            </p>
            <p>
              Автор отберёт пятерых победителей,
              рассказы которых будут напечатаны издательством «Т8» в специальном сборнике.
            </p>
            <p>
              На конкурс принимаются работы в нескольких жанрах.&nbsp;
              Подробности вы можете посмотреть в разделе «Условия участия».
            </p>
            <br />
            <b>Сроки проведения конкурса</b>
            <p>Прием заявок: до 30.11.2023 года включительно.</p>
            <p>Формирование шорт-листа:&nbsp; с 1 по 16 декабря 2023 года.</p>
            <p>Оглашение победителей: 29 декабря 2023 года.</p>
            <p>Сроки могут быть изменены по решению организаторов.</p>
            <br />
            <b>Приз</b>
            <p>Публикация в сборнике рассказов + экземпляр сборника каждому победителю, подписанный Ясминой Сапфир.</p>
            <p>
              Дополнительный приз за самую понравившуюся работу лично от Ясмины:
              4 000 рублей одному из прошедших в сборник участников.
            </p>
            <br />
            <b>Условия участия</b>
            <p>
              1) Рассказ должен быть написан только по миру Перекрестья.
              Вы можете использовать любую расу, часть мира.
              Описать город не упомянутый в цикле, но при этом сохранить уникальные расы.
            </p>
            <p>НЕТ: демонам, эльфам, гномам, хоббитам, фейри и другим классическим расам;</p>
            <br />
            <p>2) Рассказ должен оставаться в рамках 16+.</p>
            <p>
              Мы говорим решительное НЕТ: всему, что противоречит законодательству РФ,
              а так же МЖМ и ЖМЖ (никаких тройничков в эпилоге!);
            </p>
            <br />
            <p>
              3) Для того чтобы податься на конкурс необходимо выложить
              20000 знаков с пробелами и поставить тег «Конкурс рассказов Сапфир»;
            </p>
            <br />
            <p>4) Рассказ не должен превышать 2 ал (80 0000 знаков с пробелами);</p>
            <br />
            <p>
              5) Текст должен быть грамотный,
              это плюс в вашу авторскую карму и обязательное условие от издательства Т8;
            </p>
            <br />
            <p>6) Рассказ должен быть логически завершенным;</p>
            <br />
            <p>
              7) Вы можете подать несколько рассказов, если успеете завершить все,
              но в сборник в случае победы попадет только один. Какой? На выбор жюри;
            </p>
            <br />
            <p>
              8) Рассказ должен быть бесплатным и выложен полностью не позднее
              завершения приема заявок (до 31.05.2023 включительно).
            </p>
            <br />
            <p>
              9) Рассказ должен относится к жанру (одному или нескольким,
              на ваш выбор): «Магические академии», «Юмористическая фантастика», «Любовная фантастика».&nbsp;
            </p>
            <br />
            <p>
              Как опубликовать рассказ, выбрать жанр и поставить теги —&nbsp; читайте
              {' '}
              <a href="/contests/story-sapphire/how-to-publication-story.pdf">ТУТ (ссылка)</a>
            </p>
          </>
        ),
      }}
    />
  );
};
